import './App.css';
import ChatBot from 'react-simple-chatbot';
import { useEffect, useState } from 'react';
import { ThemeProvider } from 'styled-components';
import flotanteChat from  './img/chatbot.png';
import avatarUsuario from './img/perfil2.png';
import avatarChatbot from './img/farinter-avatar.png';

function App() {
  const config = {
    width: '300px',
    height: '400px',
    floating: true,
    floatingStyle: {
      width: '70px', height: '70px', background: 'white',
      // boxshadow: 'none',
    },
    floatingIconStyle: { height: '60px', width: '60px' },
  };

  //  var link = window.location.href = "mailto:mail@example.org";
  const theme = {
    background: 'white',
    fontFamily: 'Arial, Helvetica, sans-serif',
    headerBgColor: 'radial-gradient(circle, rgba(9,9,121,0.958420868347339) 15%, rgba(9,9,121,0.958420868347339) 22%, rgba(0,212,255,1) 100%);',
    headerFontColor: '#fff',
    headerFontSize: '25px',
    botBubbleColor: '#0c87e7',
    botFontColor: '#fff',
    userBubbleColor: '#C0C0C0',
    userFontColor: '#fff',
  };
  const [steps, setsteps] = useState();
  useEffect(() => {
    try {
      const newSteps = JSON.parse(document.getElementById('chatbotdata').textContent);
      setsteps(newSteps);
    } catch (error) {
      console.log(error);
    }
  }, [])
  if (!steps) {
    return <div></div>
  }
  return (
    <ThemeProvider theme={theme}>
      <ChatBot steps={steps} {...config} headerTitle="Chatbot" botAvatar={avatarChatbot} floatingIcon={avatarChatbot} userAvatar={avatarUsuario} placeholder="Escribe tu mensaje..." />
    </ThemeProvider>
  );
}

export default App;
